import {
  DeleteDamagedAdjusterAttachedImagesPropsType,
  DeleteDamagedAdjusterAttachedImagesQueryParamsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteDamagedAdjusterAttachedImages/deleteDamagedAdjusterAttachedImagesQuery.type';
import { deleteDamagedAdjusterAttachedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteDamagedAdjusterAttachedImages/deleteDamagedAdjusterAttachedImagesQueryFunction';

export const deleteDamagedAdjusterAttachedImagesQueryOptions = ({
  type,
  fileType,
}: DeleteDamagedAdjusterAttachedImagesPropsType) => {
  return {
    mutationKey: ['deleteDamagedAdjusterAttachedImages'],
    mutationFn: (params: DeleteDamagedAdjusterAttachedImagesQueryParamsType) =>
      deleteDamagedAdjusterAttachedImagesFunction({
        ...params,
        type,
        fileType,
      }),
  };
};
